import type { Comic, ComicCategory } from '@tanko/shared'

export function filterComics<T extends Pick<Comic, 'id' | 'title' | 'author'>>(
  comics: readonly T[], assignments: readonly ComicCategory[], categories: readonly string[], query: string,
): T[] {
  const selected = new Set(categories)
  const ids = new Set(assignments.filter(a => selected.has(a.categoryId)).map(a => a.comicId))
  const search = query.trim().toLocaleLowerCase()
  return comics.filter(comic =>
    (!selected.size || ids.has(comic.id)) &&
    (!search || `${comic.title}\n${comic.author}`.toLocaleLowerCase().includes(search)),
  )
}
